// eslint-disable-next-line boundaries/no-unknown-files
import camelcaseKeys from 'camelcase-keys';
import qs from 'qs';
import { EventType } from '#types/eventBus';
import { evaluateLoginMethods } from '#utils/evaluateLoginMethods';
import { getIdentityProviderUrl } from '#utils/getIdentityProviderUrl';
import { getRequiredParams } from '#utils/getRequiredParams';
import { preloadImages } from '#utils/image';
import { preloadRequest } from '#utils/preloadRequest';
const parseResponseData = url =>
// eslint-disable-next-line @sbercloud/external-query-tools/blocked
fetch(url).then(data => data.json()).then(parsedData => camelcaseKeys(parsedData, {
  deep: true
}));
const handleLoginMethods = loginMethods => {
  if (evaluateLoginMethods(loginMethods).shouldRedirectToSingleIdProvider) {
    const [{
      id
    }] = loginMethods.identityProviders ?? [];
    if (id) {
      window.location.href = getIdentityProviderUrl(id);
    }
  }
};
const preloadMainRequests = async () => {
  const requiredParams = getRequiredParams();
  const requiredParamsStr = Object.keys(requiredParams).length ? `?${qs.stringify(requiredParams)}` : '';
  const getPreloadUrl = baseUrl => `${baseUrl}${requiredParamsStr}`;
  preloadRequest({
    readyEvent: EventType.READY_GET_AUTH_STATE,
    loadedEvent: EventType.AUTH_STATE_LOADED,
    loadData: () => parseResponseData(getPreloadUrl('/api/v1/login/state'))
  });
  preloadRequest({
    readyEvent: EventType.READY_GET_LOGIN_METHODS,
    loadedEvent: EventType.LOGIN_METHODS_LOADED,
    loadData: () => parseResponseData(getPreloadUrl('/api/v1/login/methods'))
  }).then(handleLoginMethods);
  const [preferences, theme] = await Promise.all([preloadRequest({
    readyEvent: EventType.READY_GET_PREFERENCES,
    loadedEvent: EventType.PREFERENCES_LOADED,
    loadData: () => parseResponseData(getPreloadUrl('/api/v1/login/preferences'))
  }), preloadRequest({
    readyEvent: EventType.READY_GET_THEME,
    loadedEvent: EventType.THEME_LOADED,
    loadData: () => parseResponseData(getPreloadUrl('/api/v1/theme'))
  })]);
  preloadImages(preferences.clientId ?? '', theme);
};
preloadMainRequests();